import React from "react";

export function MiniGrantApplication() {
  return (
    <div className="fqxi-shortcodes-miniGrantApplication"></div>
  );
}
